import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { parseAudience } from './-components/contact/audiences';

/** No UI: the questionnaire is the shell's (`contact.tsx`), so switching audience or tab never remounts it. */
export const Route = createFileRoute('/www/contact/$audience')({
	// Otherwise the parent draws the chooser at an invented URL: the soft 404 `/new/$` exists to avoid.
	beforeLoad: ({ params }) => {
		if (!parseAudience(params.audience)) throw notFound();
	},
	component: Outlet,
});
